import { IssueSorterColumn } from '@/presentation/components/issue-table/hooks/useSorter';
import { IssueFilterParams } from '@/presentation/store/issue';

export const INIT_FILTER_PARAMS: IssueFilterParams = {
  searchType: 'errorType',
  sortField: IssueSorterColumn.UploadTime,
  sortOrder: 'desc',
  appInBacks: [''],
};

export const DEFAULT_EXCEPTION_TYPE_LIST = 'Crash,Native,ExtensionCrash'; // ios 去掉 native 安卓 没有ExtensionCrash

export const DEFAULT_EXCEPTION_TYPE_LIST_IOS = 'Crash,ExtensionCrash';

export const DEFAULT_EXCEPTION_TYPE_LIST_ANDROID = 'Crash,Native';

export const DEFAULT_EXCEPTION_TYPE_LIST_HARMONY = 'Crash,Native';

export const EXCEPTION_TYPE_LIST = {
  crash: DEFAULT_EXCEPTION_TYPE_LIST,
  anr: 'ANR',
  error: 'AllCatched,Unity3D,Lua,JS',
  crashes: DEFAULT_EXCEPTION_TYPE_LIST,
  blocks: 'ANR',
  errors: 'AllCatched,Unity3D,Lua,JS',
  flutterrors: 'Dart',
};

export const ANDROID_EXCEPTION_TYPE_LIST_OPTIONS = [
  { label: '所有', value: DEFAULT_EXCEPTION_TYPE_LIST_ANDROID },
  { label: 'Java崩溃', value: 'Crash' },
  { label: 'Native崩溃', value: 'Native' },
];

export const HARMONY_EXCEPTION_TYPE_LIST_OPTIONS = [
  { label: '所有', value: DEFAULT_EXCEPTION_TYPE_LIST_HARMONY },
  { label: 'JS崩溃', value: 'Crash' },
  { label: 'Native崩溃', value: 'Native' },
];

export const IOS_EXCEPTION_TYPE_LIST_OPTIONS = [
  { label: '所有', value: DEFAULT_EXCEPTION_TYPE_LIST_IOS },
  { label: 'App崩溃', value: 'Crash' },
  { label: 'Extension崩溃', value: 'ExtensionCrash' },
];

export const ANR_EXCEPTION_TYPE_LIST_OPTIONS = [{ label: 'ANR', value: 'ANR' }];

export const ERROR_EXCEPTION_TYPE_LIST_OPTIONS = [
  { label: '所有', value: EXCEPTION_TYPE_LIST.error },
  { label: '自定义错误', value: 'AllCatched' },
  { label: 'C#脚本错误', value: 'Unity3D' },
  { label: 'Lua脚本错误', value: 'Lua' },
  { label: 'JS脚本错误', value: 'JS' },
];

export const ERROR_FLUTTER_EXCEPTION_TYPE_LIST_OPTIONS = [
  { label: 'Dart错误', value: 'Dart' },
];

export enum IssueStatus {
  All = 'all',
  UnProcessed = '0',
  Processed = '1',
  Processing = '2',
  ToTapd = '6'
}

export enum TextMatchRule {
  Equal = '',
  Contains = 'MATCH',
  StartWith = 'PREFIX',
  EndWith = 'SUFFIX',
  LessThan = 'LT'
}

export const REPORT_ISSUE_FORM_LABEL: { [key: string]: string} = {
  // 通用
  timeQuick: '时间范围',
  tapdStatus: '提单状态',
  tagColor: '标签颜色',
  osVersion: '系统版本',
  bizExtendInfo: '自定义字段',
  bundleId: 'Bundle ID',
  processName: '出错进程',
  maxAppVersion: 'APP版本',
  minAppVersion: 'APP版本',
  wildcardAppVersion: 'APP版本',

  // 质量
  version: 'APP版本',
  contectInfo: '用户ID',
  deviceId: '设备ID',
  detail: '出错堆栈',
  appInBack: '前后台状态',
  launchTimeMax: '使用时长（秒）',
  deviceType: '设备类型',
  platform: '平台',
  status: '处理状态',
  processor: '处理人',
  newTagList: '标签',
  channelId: '渠道',
  cpuArch: '运行时架构',
  cpuArchitecture: 'CPU架构',
  issueId: 'Issue ID',
  crashId: '消息ID',
  errorType: '异常名称',
  hardware: '机型',
  threadName: '出错线程',

  // 性能
  appVersionGroup: 'APP版本',
  appVersionMode: '版本类型',
  ground: '前后台状态',
  scene: '场景',
  accountId: '用户ID',
  clientIdentify: '消息ID',
  costTimeAvgMax: '卡顿平均耗时(毫秒) max',
  costTimeAvgMin: '卡顿平均耗时(毫秒) min',
  feature: 'Issue ID',
  funcName: '问题特征',
  issueStatus: '处理状态',
  model: '机型',
  monitoredThreadName: '监控线程',
  qimei: '设备ID',
  sdkVersion: 'SDK版本',
  systemStack: '系统堆栈',
  tags: '标签',
  tapdHandler: '处理人',
  topNum: 'Top问题数',
  userCustom: '自定义维度',
  leakBytesMax: '最大泄漏内存(KB) max',
  leakBytesMin: '最大泄漏内存(KB) min',
  fdType: 'FD类型',
  activityName: '页面',
  showType: '视图类型',
  launchTags: '自定义tag',
  maxLaunchCost: '启动耗时max',
  minLaunchCost: '启动耗时min',
  maxSpanCost: 'Span耗时max',
  minSpanCost: 'Span耗时min',
  avgMaxMallocSize: '最大分配堆栈均值（MB）',
  docCount: '影响次数',
  maxMallocSize: '最大分配堆栈范围（MB）',
  p50MaxMallocSize: '分配内存P50（MB）',
  p90MaxMallocSize: '分配内存P90（MB）',
  qimeiCount: '影响设备数',
  usedMem: 'FOOM前内存（MB）',
};
